import { booleanAttribute, ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonAppearance, MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'la-button',
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterModule, MatButtonModule, MatTooltipModule, MatIconModule],
})
export class ButtonComponent {
  @Input() type: 'button' | 'submit' | 'reset' = 'button';
  @Input() appearance: 'primary' | 'basic' | 'outlined' | 'tonal' = 'basic';
  @Input() color: 'normal' | 'warn' | 'flat' | 'tertiary' = 'normal';
  @Input() icon?: string;
  @Input() iconRight?: string;
  @Input() disabled = false;
  @Input() buttonLink?: string[] | string | null | undefined;

  @Input({ transform: booleanAttribute }) alignLeft = false;
  @Input({ transform: booleanAttribute }) dense = false;

  @Input() tooltipForEnabled?: string;
  @Input() tooltipForDisabled?: string;

  @Output() action = new EventEmitter<void>();

  get matButtonType(): MatButtonAppearance {
    return this.appearance === 'primary'
      ? 'filled'
      : this.appearance === 'basic'
        ? 'text'
        : this.appearance === 'outlined'
          ? 'outlined'
          : 'tonal';
  }

  get hasTooltip(): boolean {
    return !!this.tooltipForDisabled || !!this.tooltipForEnabled;
  }

  get tooltip(): string | undefined {
    return this.disabled ? this.tooltipForDisabled : this.tooltipForEnabled;
  }
}
